export enum IconStatisticCard {
  FourRectangle = '/media/icons/duotune/general/gen024.svg',
  Application = '/media/icons/duotune/general/gen022.svg',
  Recognition = '/media/icons/duotune/technology/teh001.svg',
  Server = '/media/icons/duotune/abstract/abs045.svg',
}
